import React from "react";
import { FOOTER_MARK } from "../assets/images";

function Footer() {
  return (
    <footer className="shrink-0 border-t border-slate-200/80 bg-white px-3 py-2 sm:px-4">
      <div className="mx-auto flex w-full max-w-[min(100%,1400px)] items-center justify-center gap-2 text-xs text-slate-500">
        <img src={FOOTER_MARK} alt="" className="h-4 w-auto opacity-70" />
        <span>© {new Date().getFullYear()} Chanuka Bursary</span>
        <span>·</span>
        <a
          href="https://bursary.ktdafoundation.or.ke"
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-[#0057A5] hover:underline"
        >
          bursary.ktdafoundation.or.ke
        </a>
      </div>
    </footer>
  );
}

export default Footer;
